import React, { Component } from "react";
import Dashboard from "./Dashboard/dashboard";
import Login from "./login";
import Register from "./register";
import { fire } from "./Firebase/firebase";
import { Route, BrowserRouter as Router } from "react-router-dom";
import AuthorizedRoute from "./AuthorizedRoute";
import Profile from "./Dashboard/profile";
import favouriteUsers from "./Dashboard/favouriteUsers";
import ballsCaught from "./Dashboard/ballsCaught";
import { AnimatedSwitch } from 'react-router-transition';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      user: null,
      currentLatLng: {
        lat: 0,
        lng: 0
      }
    };
  }

//Check if user is logged in
  componentDidMount() {
    this.setAuthObserver();
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          authenticated: true,
          user: user
        });

        console.log("user is signed in");
      } else {
        this.setState({
          authenticated: false
        });
        console.log("user is not signed in");
      }
    });
   
    this.showCurrentLocation();
  }

  setAuthObserver() {
    return fire.auth().onAuthStateChanged(user => this.setState({ user }));
  }

// Get current location for it to be passed down onto map.js
  showCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.setState(prevState => ({
          currentLatLng: {
            ...prevState.currentLatLng,
            lat: position.coords.latitude,
            lng: position.coords.longitude
          },
          isMarkerShown: true
        }));
      });
    } else {
      console.log("error");
    }
  };

  // https://github.com/ReactTraining/react-router/issues/4105
  render() {
    const { authenticated, user } = this.state;

    return (
      <Router>
      
       <div>
          <Route
            exact
            path="/"
            render={props => <Login {...props} authenticated={authenticated} />}
          />
          <Route
            path="/register"
            render={props => (
              <Register {...props} authenticated={authenticated} />
            )}
          />
          <AuthorizedRoute
            path="/dashboard"
            component={Dashboard}
            authenticated={authenticated}
            user={user}
            currentLocation={this.state.currentLatLng}
          />
          <Route
            path="/profile"
            render={props => (
              <Profile {...props} authenticated={authenticated} />
            )}
          />
          <Route path="/favourite_users" component={favouriteUsers} />
          <Route path="/balls_caught" component={ballsCaught} />
          </div>
      </Router>
    );
  }
}

export default App;
